"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyOfAttrFormatter = anyOfAttrFormatter;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const attribute_js_1 = require("./attribute.js");
function* anyOfAttrFormatter(attribute, rawValue, options = {}) {
    const { format = true, transform = true, valuePath } = options;
    let formatter = undefined;
    let _transformedValue = undefined;
    let _formattedValue = undefined;
    for (const element of attribute.elements) {
        try {
            formatter = (0, attribute_js_1.attrFormatter)(element, rawValue, options);
            if (transform) {
                _transformedValue = formatter.next().value;
            }
            _formattedValue = formatter.next().value;
            break;
        }
        catch (error) {
            continue;
        }
    }
    const transformedValue = _transformedValue;
    const formattedValue = _formattedValue;
    if (formatter === undefined || formattedValue === undefined) {
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        throw new index_js_1.DynamoDBToolboxError('formatter.invalidAttribute', {
            message: `Invalid attribute detected while formatting. Attribute does not match any of the possible sub-types${path !== undefined ? `: '${path}'` : ''}.`,
            path,
            payload: { received: rawValue }
        });
    }
    if (transform) {
        if (format) {
            yield transformedValue;
        }
        else {
            return transformedValue;
        }
    }
    return formattedValue;
}
